module.exports = __webpack_public_path__ + "img/H3.d28d606c.png";